'use strict';

import angular from 'angular';

export default function f($rootScope, $http, $stateParams, $state, $q, utils, userModel, currencyModel, currencySymbol, currencies, objectToArray, featuredGuides, placesService, languages, seoActivities, deslug) {
  'ngInject';

  var currencyCode = currencyModel.getValue();
  var currencySym = currencySymbol(currencyCode);
  var maximumValue = currencies.filter(currency => currency.code === currencyCode)[0].maxSearchValue;
  var isFilterBoxVisible = false;
  var oldFilters = {};
  // TODO: document how it works
  var featuredGuidesFlag = false;
  var filters = {};
  filters.priceFrom = $stateParams.priceFrom || 0;
  filters.priceTo = $stateParams.priceTo || maximumValue;
  filters.currency = $stateParams.currency || currencyCode;
  filters.location = {};
  filters.gender = {};
  filters.languages = {};
  filters.activities = {};

  var sliderOptions = {
    options: {
      floor: 0,
      ceil: maximumValue,
      translate: function(value) {
        if (value === 0) {
          return 'Free';
        } else {
          return currencySym + value + '/h';
        }
      }
    }
  };

  $rootScope.$on('$stateChangeStart', (_, toState, toParams, fromState) => {
    if (['guides.guide'].indexOf(fromState.name) === -1 &&
      ['guides.city', 'guides.cityFilter'].indexOf(toState.name) !== -1) {
      clearFilters();
    }
  });

  function updateFromUserParams() {
    // #TODO#1356
    // the user model loading is not guaranteed to be sooner than this code
    // execution which poses the question - if the user saved his filters,
    // how do we update them?

    // Init filters from saved state (URL params take precendence)
    // TODO: implement URL precedence
    if (userModel.item.preferences) {
      if (notEmpty(userModel.item.preferences.filter)) {
        var userFilters = userModel.item.preferences.filter;
        filters.priceFrom = userFilters.priceFrom || 0;
        filters.priceTo = userFilters.priceTo || maximumValue;
        filters.currency = currencyCode;
        if (userFilters.location) {
          filters.location.name = userFilters.location.name;
          filters.location.placeId = userFilters.location.placeId;
          filters.location.lat = userFilters.location.lat;
          filters.location.lon = userFilters.location.lon;
          filters.location.countryCode = userFilters.location.countryCode;
          filters.location.px1 = userFilters.location.px1;
          filters.location.py1 = userFilters.location.py1;
          filters.location.px2 = userFilters.location.px2;
          filters.location.py2 = userFilters.location.py2;
        }
        filters.languages = arrayToObjectBoolean(userFilters.languages);
        filters.activities = arrayToObjectBoolean(userFilters.activities);
        filters.gender = arrayToObjectBoolean(userFilters.gender);
        filters.saveFilterOptions = true;
      }
    } else {
      var localStorage = false;
      if (localStorage) {
        localStorage = true;
        // TODO: implement
      }
    }
  }

  function clearFilters() {
    //TODO: copy initial state from constructor ar reset to it
    filters.priceFrom = 0;
    filters.priceTo = maximumValue;
    filters.currency = currencyCode;
    filters.location = {};
    filters.languages = {};
    filters.activities = {};
    filters.gender = {};
    filters.filter = undefined;
    $stateParams.filter = undefined;
    $stateParams.activities = undefined;
    $stateParams.countryCode = undefined;
    $stateParams.gender = undefined;
    $stateParams.idlist = undefined;
    $stateParams.languages = undefined;
    $stateParams.lat = undefined;
    $stateParams.loc = undefined;
    $stateParams.lon = undefined;
    $stateParams.name = undefined;
    $stateParams.placeId = undefined;
    $stateParams.priceFrom = undefined;
    $stateParams.priceTo = undefined;
    $stateParams.px1 = undefined;
    $stateParams.px2 = undefined;
    $stateParams.py1 = undefined;
    $stateParams.py2 = undefined;
  }

  updateFromUserParams();

  function notEmpty(filters) {
    return filters !== null
      && (filters.priceFrom !== null
      || filters.priceTo !== null
      || filters.currency !== null
      || filters.languages.length > 0
      || filters.activities.length > 0
      || filters.gender.length > 0);
  }

  // Convert for usage in POST to the backend
  function convertFilters(rawFilters) {
    if (rawFilters === null) {
      return null;
    }
    var filterCopy = angular.copy(rawFilters);
    filterCopy.languages = objectToArray.transform(filterCopy.languages);
    filterCopy.activities = objectToArray.transform(filterCopy.activities);
    filterCopy.gender = objectToArray.transform(filterCopy.gender);
    delete filterCopy.saveFilterOptions;
    return filterCopy;
  }

  // Convert backend saved filter data for usage on the form
  function arrayToObjectBoolean(array) {
    var object = {};
    array.forEach((item) => {
      object[item] = true;
    });

    return object;
  }

  function updateAdditionalLocationParams(from, to) {
    // Reset these params because some location don't have them
    // and previous location parameters are used in such cases
    to.px1 = null;
    to.px2 = null;
    to.py1 = null;
    to.py2 = null;

    if (from.lat) {
      to.lat = from.lat;
    }
    if (from.lon) {
      to.lon = from.lon;
    }
    if (from.countryCode) {
      to.countryCode = from.countryCode;
    }
    if (from.px1) {
      to.px1 = from.px1;
    }
    if (from.py1) {
      to.py1 = from.py1;
    }
    if (from.px2) {
      to.px2 = from.px2;
    }
    if (from.py2) {
      to.py2 = from.py2;
    }
  }

  function updateFromParams() {
    let city = '';
    let country = '';
    var location = {};

    // Workadround for SEO url's to ignore female filter.
    // AK Request on 2019-08-27.
    //if ($stateParams.filter === 'male' || $stateParams.filter === 'female' || $stateParams.filter === 'couple') {
    //  $stateParams.filter = null;
    //}

    if ($stateParams.priceFrom) {
      filters.priceFrom = $stateParams.priceFrom;
    }
    if ($stateParams.priceTo) {
      filters.priceTo = $stateParams.priceTo;
    }
    if ($stateParams.currency) {
      filters.currency = $stateParams.currency;
    }
    if ($stateParams.placeId) {
      location.name = $stateParams.name;
      location.placeId = $stateParams.placeId;
      filters.location = location;
      updateAdditionalLocationParams($stateParams, filters.location);
    } else if ($stateParams.country && $stateParams.city)  {
      city = deslug.it($stateParams.city);
      country = deslug.it($stateParams.country);
      location.name = `${city}, ${country}`;
      filters.location = location;
    } else {
      filters.location = {};
    }
    if ($stateParams.loc) {
      filters.location.loc = $stateParams.loc;
    }
    if ($stateParams.idlist) {
      filters.location.idlist = $stateParams.idlist;
    }

    if ($stateParams.languages) {
      filters.languages = arrayToObjectBoolean($stateParams.languages.split(','));
    }
    if ($stateParams.activities) {
      filters.activities = arrayToObjectBoolean($stateParams.activities.split(','));
    }
    if ($stateParams.gender) {
      filters.gender = arrayToObjectBoolean($stateParams.gender.split(','));
    }
    if ($stateParams.filter) {
      filters.filter = $stateParams.filter;

      if (['male', 'female', 'couple'].indexOf(filters.filter) !== -1) {
        filters.gender[filters.filter] = true;
      } else if (Object.keys(languages.all).indexOf(filters.filter) !== -1) {
        filters.languages[filters.filter] = true;
      } else {
        if (Object.keys(seoActivities).indexOf(filters.filter) !== -1) {
          filters.filter = seoActivities[filters.filter];
        }
        filters.activities[filters.filter] = true;
      }
    }
  }

  function getDetails(loc, params, resolve) {
    placesService.getDetails(loc, (detailedLocation) => {
      updateAdditionalLocationParams(detailedLocation, params);
      updateAdditionalLocationParams(detailedLocation, loc);
      resolve(params);
      // TODO: does this cause history problems?
      // $state.go('.', params, {notify: false, location: 'replace'});
    });
  }

  function getParametrizedFilters() {
    return new $q((resolve) => {
      if (featuredGuidesFlag) {
        featuredGuidesFlag = false;
        return {};
      }
      var params = angular.copy(filters);
      params.location = null;

      params.activities = objectToArray.transform(params.activities).join(',');
      params.languages = objectToArray.transform(params.languages).join(',');
      params.gender = objectToArray.transform(params.gender).join(',');

      delete params.saveFilterOptions;
      params.currency = currencyModel.getValue();
      if (params.priceTo == maximumValue) {
        params.priceTo = null;
      }
      if (params.priceFrom == 0) {
        params.priceFrom = null;
      }

      if (filters.location) {
        if (filters.location.name) {
          params.name = filters.location.name;
        }
        if (filters.location.placeId) {
          params.placeId = filters.location.placeId;
        }
        if (filters.location.lat) {
          params.lat = filters.location.lat;
        }
        if (filters.location.lon) {
          params.lon = filters.location.lon;
        }
        if (filters.location.countryCode) {
          params.countryCode = filters.location.countryCode;
        }

        if (filters.location.px1) {
          params.px1 = filters.location.px1;
        }
        if (filters.location.py1) {
          params.py1 = filters.location.py1;
        }
        if (filters.location.px2) {
          params.px2 = filters.location.px2;
        }
        if (filters.location.py2) {
          params.py2 = filters.location.py2;
        }
      } else {
        // TODO: ehhh, something better?
        params.name = null;
        params.placeId = '';
        params.lat = '';
        params.lon = '';
        params.countryCode = '';
        params.px1 = '';
        params.px2 = '';
        params.py1 = '';
        params.py2 = '';
      }

      // load additional location data
      if (filters.location && filters.location.name
        && (!$stateParams.lat || ($stateParams.name !== filters.location.name))) {
        if (!filters.location.placeId) {
          let city = $stateParams.city;
          //if (city === 'kiev') {
          //  city = 'kyiv';
          //}
          placesService.getPlaceId(city).then((response) => {
            filters.location.placeId = params.placeId = response.data.placeId;
            getDetails(filters.location, params, resolve);
          });
        } else {
          getDetails(filters.location, params, resolve);
        }
      } else {
        resolve(params);
        // TODO: does this cause history problems?
        // $state.go('.', params, {notify: false, location: 'replace'});
      }
    });
  }

  return {
    filters: filters,
    userFilterUpdated: false,
    filtersActive: false,

    updateFromParams() {
      updateFromParams();
    },

    setFeaturedGuides(cond) {
      featuredGuidesFlag = cond;
    },

    updateFromUserParams() {
      updateFromUserParams();
    },

    notEmpty(userFilters) {
      if (!userFilters) {
        userFilters = filters;
      }
      var notEmpty = userFilters.priceFrom != 0
        || userFilters.priceTo != maximumValue
        || objectToArray.transform(userFilters.languages).length > 0
        || objectToArray.transform(userFilters.activities).length > 0
        || objectToArray.transform(userFilters.gender).length > 0;

      this.filtersActive = notEmpty;

      return notEmpty;
    },

    getParametrizedFilters() {
      return getParametrizedFilters();
    },

    filterBoxVisibility() {
      return isFilterBoxVisible;
    },

    setFilterBoxVisibility(isVisible) {
      isFilterBoxVisible = isVisible;
    },

    getSliderOptions() {
      return sliderOptions;
    },

    setSliderOptions(options) {
      angular.extend(sliderOptions, options);
    },

    getLocation() {
      return filters.location;
    },

    persistFilterOptions(userFilters) {
      if (!angular.equals(oldFilters, userFilters)) {
        if (userModel.item.id) {
          var convertedFilters = null;
          if (notEmpty(userFilters)) {
            convertedFilters = convertFilters(userFilters);
          }
          oldFilters = angular.copy(userFilters);
          $http.post(utils.getApiUrlV2('users/' + userModel.item.id + '/filters'), convertedFilters, { params: null });
        } else {
          // guest localstorage
        }
      }
    },

    clearFilters() {
      return clearFilters();
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/guide_search_filters.service.js